import React from 'react';
import { Link } from 'react-router-dom';
import Services from "../../api/Services";
import Imgage from '../../images/service/icon-1.svg'
import mr01 from '../../images/mr01.png'
import mr02 from '../../images/mr02.png'
import mr03 from '../../images/mr03.png'





const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const ServiceSectionS3 = () => {
    return (
        <section className="service-section-s3 section-padding">
            <div className="container">
                <div className="title" style={{marginBottom:"50px"}}>
                    <h2 className="scroll-text-animation" data-animation="fade_from_bottom">Mrmetallo</h2>
                    <div className="title-bottom">
                        <h3 className="scroll-text-animation" data-animation="fade_from_bottom" style={{fontSize: window.innerWidth >= 768 ? "48px" : "30px"}}>산업폐수처리 전문 { (window.innerWidth < 400 ) && <br /> } 일등 기업</h3>
                    </div>
                </div>
                <div className="row scroll-text-animation" data-animation="fade_from_buttom">
                    <div className="col-lg-4 col-md-6 col-12" >
                        <div className="service-card-s3" style={{backgroundImage: `url(${mr01})`, backgroundSize: 'cover', backgroundPosition: 'center', height:window.innerWidth >= 768 ? "380px" : "300px", display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
                            {/* <div className="icon">
                                <img src={Imgage} alt="" />
                            </div> */}
                            <h2><span className="num">{1}.</span><a onClick={ClickHandler} style={{color:"#FFFFFF"}} > 환경을 위한 기업</a></h2>
                            <p style={{color:"#FFFFFF"}}>
                                산업폐수 처리를 통해 <br />
                                환경을 더욱 살리고 있습니다
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12" >
                        <div className="service-card-s3" style={{backgroundImage: `url(${mr02})`, backgroundSize: 'cover', backgroundPosition: 'center', height:window.innerWidth >= 768 ? "380px" : "300px", display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
                            {/* <div className="icon">
                                <img src={Imgage} alt="" />
                            </div> */}
                            <h2><span className="num">{2}.</span><a onClick={ClickHandler} style={{color:"#FFFFFF"}} > 폐수처리 전문 기업</a></h2>
                            <p style={{color:"#FFFFFF"}}>
                                20여년의 폐수처리 전문 <br />
                                기업입니다.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12" >
                        <div className="service-card-s3" style={{backgroundImage: `url(${mr03})`, backgroundSize: 'cover', backgroundPosition: 'center', height:window.innerWidth >= 768 ? "380px" : "300px", display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
                            {/* <div className="icon">
                                <img src={Imgage} alt="" />
                            </div> */}
                            <h2><span className="num">{3}.</span><a onClick={ClickHandler} style={{color:"#FFFFFF"}} > 신속한 프로세스</a></h2>
                            <p style={{color:"#FFFFFF"}}>
                                의뢰, 분석, 수거 등 <br />
                                매끄러운 프로세스를 보유합니다.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSectionS3;